























































































import Vue from 'vue';
import {
  firebase,
  // collectionNames,
  analytics,
  calender,
} from 'mostra';

// const sleep = async (msec: number): Promise<void> => new Promise((resolve) => {
//   setTimeout(() => {
//     resolve();
//   }, msec);
// });

interface DataType {
  btpv: any;
  ls: any[];
}

export default Vue.extend({
  name: 'admin-text-cleansing',
  data(): DataType {
    return {
      btpv: {},
      ls: [],
    };
  },
  methods: {
    formatDateTime(dt: any) {
      return calender.formatDateTime(dt);
    },
    async onClick() {
      try {
        // const btpv = await analytics.calcPVOfBooth("6h2bbgzsvPWvN7sOOGHd", "8vl20ySNDrPWxrVgKX6u");
        const btpv = await analytics.calcPVOfBooth('9funZBzae8oOkjjnifFk', 'mn3G0BwlAKVLG24hAjDG');
        this.btpv = btpv;
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.$loading(false);
      }
    },
    async onClick2() {
      try {
        // const names = ['bt-boothId', 'exh-exhibitionId-bt-boothId'];
        const names = ['exh-exhibitionId'];

        const qs = await firebase
          .db()
          .collection('visitors_v1')
          // .where('brandId', '==', '9funZBzae8oOkjjnifFk')
          // .where('boothId', '==', '8vl20ySNDrPWxrVgKX6u')
          // .where('boothId', '==', 'mn3G0BwlAKVLG24hAjDG')
          // .where('boothId', '==', 'mn3G0BwlAKVLG24hAjDG')
          .where('exhibitionId', '==', 'Od1JqPeXugXF6aF2EQjG')
          .where('name', 'in', names)
          .get();

        const ls: any[] = [];
        qs.forEach((doc) => {
          ls.push(doc.data());
        });

        // const btpv = await analytics.calcPVOfBooth("6h2bbgzsvPWvN7sOOGHd", "8vl20ySNDrPWxrVgKX6u");
        // const btpv = await analytics.calcPVOfBooth('9funZBzae8oOkjjnifFk', 'mn3G0BwlAKVLG24hAjDG');
        this.ls = ls;
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.$loading(false);
      }
    },

  },
});
